<template>
    <b-form-group :label="label"
        :invalid-feedback="errorTxt"
        :state="state">
        <b-input-group :prepend="$t('recording')">
            <b-form-select
                v-model="inputVal"
                :options="options"
                :state="state">
            </b-form-select>
        </b-input-group>
    </b-form-group>
</template>

<script>
    export default {
        component: {},
        props: ['model', 'label', 'errors', 'disabled', 'attribute'],
        data() {
            return {
                inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
                state: null,
                errorTxt: '',
                options: []
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute] ? val[this.attribute] : null;
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                this.state = !hasErr;
            }
        },
        methods: {
            load() {
                this.options = [
                    {value: null, text: this.$t('selectRecording')}
                ];
                this.$bgService.get('/recording', {
                    params: {
                        page: 1,
                        pageSize: 1000,
                        status: 0
                    }
                }).then(response => {
                    let found = false;
                    response.data.docs.forEach(item => {
                        this.options.push({value: item._id, text: item.name});
                        if (item._id === this.model[this.attribute]) {
                            found = true;
                        }
                    });
                    if (!found) {
                        this.inputVal = null;
                    }
                });
            }
        },
        mounted() {
            this.$bus.$on('reloadRecordingSelect', this.load);
            this.load();
        },
        beforeDestroy() {
            this.$bus.$off('reloadRecordingSelect');
        }
    }
</script>